import React from "react"
import TabletImgForDesktop from "./engineid-on-tablet-desktop-min.png"
import Article from "./Article"
import EmptyBlock from "./EmptyBlock"
import styles from "./BannerHome.module.scss"
import BannerContainer from "@components/BannerContainer"

const BannerWWD = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <Article />
            <EmptyBlock className={styles.emptyBlockLeft} />
          </React.Fragment>
        )
      }}
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <div className={styles.tabletContainer + " mx-auto"}>
              <img
                src={TabletImgForDesktop}
                alt="EngineID on a tablet device"
                className={styles.tabletImg}
              />
            </div>
            <EmptyBlock className={styles.emptyBlockRight} />
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerWWD
